import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const NextActionPayment = () => {
  const { customBorderRadius } = useCustomTheme();
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  if (!checkoutSessionEntity) {
    return null;
  }

  return (
    <>
      <Box width="100%">
        <Alert
          severity="info"
          style={{ borderRadius: customBorderRadius.paper, padding: 16 }}
          icon={<Icon size={18}>credit_card</Icon>}
        >
          <Box display="flex" flexDirection={'column'} gridGap={8}>
            <Font variant="body2" display="block">
              <Text strong tId={'PAY_TITLE'} />
            </Font>
            <Font variant="body2" display="block">
              <Text tId={'PAY_DESCRIPTION'} />
            </Font>
          </Box>
        </Alert>
      </Box>
    </>
  );
};
